export const selectPdpHistory = (state) => state?.pdpHistory?.pdpHistory;

export const selectBackButtonHistory = (state) => state?.pdpHistory?.backButtonHistory;
